<div class="modal-backdrop" *ngIf="isVisible" (click)="closeModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <button
      class="close-button"
      (click)="closeModal()"
      aria-label="Close modal"
    >
      &times;
    </button>

    <div class="modal-header">
      <button
        [class.active]="activeMode === 'login'"
        (click)="switchTo('login')"
      >
        Sign In
      </button>
      <button
        [class.active]="activeMode === 'signup'"
        (click)="switchTo('signup')"
      >
        Sign Up
      </button>
    </div>

    <div *ngIf="activeMode === 'login'" class="form-container login-form">
      <h2 class="welcome-text">WELCOME</h2>
      <form [formGroup]="loginForm" (ngSubmit)="onLoginSubmit()">
        <div class="form-group">
          <label for="login-email">Email</label>
          <input
            type="email"
            id="login-email"
            formControlName="email"
            placeholder="example&#64;example.com"
          />
          <div
            *ngIf="
              loginEmail?.invalid && (loginEmail?.dirty || loginEmail?.touched)
            "
            class="error-message"
          >
            <small *ngIf="loginEmail?.errors?.['required']"
              >Email is required.</small
            >
            <small *ngIf="loginEmail?.errors?.['email']"
              >Please enter a valid email address.</small
            >
          </div>
        </div>
        <div class="form-group password-input">
          <label for="login-password">Password</label>
          <div class="input-with-icon">
            <input
              [type]="showLoginPassword ? 'text' : 'password'"
              id="login-password"
              formControlName="password"
              placeholder="********"
            />
            <button
              type="button"
              class="toggle-password-visibility"
              (click)="togglePasswordVisibility('login')"
              aria-label="Toggle password visibility"
            >
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                <circle cx="12" cy="12" r="3"></circle>
              </svg>
            </button>
          </div>
          <div
            *ngIf="
              loginPassword?.invalid &&
              (loginPassword?.dirty || loginPassword?.touched)
            "
            class="error-message"
          >
            <small *ngIf="loginPassword?.errors?.['required']"
              >Password is required.</small
            >
            <small *ngIf="loginPassword?.errors?.['minlength']"
              >Password must be at least 6 characters long.</small
            >
          </div>
        </div>

        <div class="form-actions">
          <label class="remember-me">
            <input type="checkbox" /> Remember Me
          </label>
          <a href="#" class="forgot-password">Forgot Password ?</a>
        </div>

        <button
          type="submit"
          class="submit-button login-button"
          [disabled]="loginForm.invalid || loading"
        >
          {{ loading ? "Logging in..." : "Log In" }}
        </button>

        <div class="social-login">
          <hr />
          <button type="button" class="social-login-button">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path
                d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"
              ></path>
            </svg>
            Login Through Monshaat
          </button>
        </div>

        <p class="switch-prompt">
          New Here? <a (click)="switchTo('signup')">Create Account</a>
        </p>
      </form>
    </div>

    <div *ngIf="activeMode === 'signup'" class="form-container signup-form">
      <h2 class="welcome-text">WELCOME</h2>
      <form [formGroup]="signupForm" (ngSubmit)="onSignupSubmit()">
        <div class="form-group">
          <label for="signup-email">Email</label>
          <input
            type="email"
            id="signup-email"
            formControlName="email"
            placeholder="example&#64;example.com"
          />
          <div
            *ngIf="
              signupEmail?.invalid &&
              (signupEmail?.dirty || signupEmail?.touched)
            "
            class="error-message"
          >
            <small *ngIf="signupEmail?.errors?.['required']"
              >Email is required.</small
            >
            <small *ngIf="signupEmail?.errors?.['email']"
              >Please enter a valid email address.</small
            >
          </div>
        </div>

        <div class="form-group">
          <label for="signup-phone">Phone Number</label>
          <input
            type="tel"
            id="signup-phone"
            formControlName="phoneNumber"
            placeholder="0501234567"
          />
        </div>

        <div class="form-group password-input">
          <label for="signup-password">Password</label>
          <div class="input-with-icon">
            <input
              [type]="showSignupPassword ? 'text' : 'password'"
              id="signup-password"
              formControlName="password"
              placeholder="********"
            />
            <button
              type="button"
              class="toggle-password-visibility"
              (click)="togglePasswordVisibility('signup')"
              aria-label="Toggle password visibility"
            >
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                <circle cx="12" cy="12" r="3"></circle>
              </svg>
            </button>
          </div>
          <div
            *ngIf="
              signupPassword?.invalid &&
              (signupPassword?.dirty || signupPassword?.touched)
            "
            class="error-message"
          >
            <small *ngIf="signupPassword?.errors?.['required']"
              >Password is required.</small
            >
            <small *ngIf="signupPassword?.errors?.['minlength']"
              >Password must be at least 6 characters long.</small
            >
          </div>
        </div>

        <div class="form-group terms-agreement">
          <label>
            <input type="checkbox" formControlName="termsAccepted" /> I agree on
            the termes and policy
          </label>
          <div
            *ngIf="
              signupForm.get('termsAccepted')?.invalid &&
              (signupForm.get('termsAccepted')?.dirty ||
                signupForm.get('termsAccepted')?.touched)
            "
            class="error-message"
          >
            <small *ngIf="signupForm.get('termsAccepted')?.errors?.['required']"
              >You must agree to the terms and policy.</small
            >
          </div>
        </div>

        <button
          type="submit"
          class="submit-button signup-button"
          [disabled]="signupForm.invalid || loading"
        >
          {{ loading ? "Creating Account..." : "Sign Up" }}
        </button>

        <p class="switch-prompt">
          already have an account ? <a (click)="switchTo('login')">Sign In</a>
        </p>
      </form>
    </div>
  </div>
</div>
